import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import { initReactI18next } from "react-i18next";

const fallbackLng = "pl";
const availableLanguages = ["en", "pl"];
// const availableLanguages = ["pl"];
const detectionOptions = {
    order: ["path", "localStorage"],
    lookupQuerystring: "lang",
    lookupLocalStorage: "i18nextLng",
    lookupFromPathIndex: 0,
};

i18n.use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng,
        defaultLng: fallbackLng,
        debug: false,
        whitelist: availableLanguages,
        supportedLngs: availableLanguages,
        interpolation: {
            escapeValue: false,
        },
        detection: detectionOptions,
        //  nsSeparator: false,
        // keySeparator: false,
        // saveMissing: true,
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json",
        },
    });

export const getLanguage = () => {
    return i18n.language || (typeof window !== "undefined" && window.localStorage.i18nextLng) || fallbackLng;
};

export default i18n;
